import BotAppearanceSetup from "./BotAppearanceSetup";
import BotIntelligenceSetup from "./BotIntelligenceSetup";
import type { CustomStepProps } from "../types";

export const BotAppearanceStep = ({
  appearancePreviewTab,
}: CustomStepProps) => {
  return <BotAppearanceSetup appearancePreviewTab={appearancePreviewTab} />;
};

export const BotIntelligenceStep = () => {
  return <BotIntelligenceSetup />;
};
